var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { fullstory } from "@sennder/senn-node-analytics-frontend";
import { safeExec } from "../shared/executeWithLogging/index.js";
class Fullstory {
  constructor(orgId, shouldRecord, debug, logger) {
    __publicField(this, "_orgId");
    __publicField(this, "_shouldRecord");
    __publicField(this, "_debug");
    __publicField(this, "_logger");
    if (!orgId) {
      throw new Error("FullStory orgId is required");
    }
    this._orgId = orgId;
    this._logger = logger;
    this._shouldRecord = shouldRecord;
    this._debug = debug;
  }
  init() {
    safeExec(
      () => {
        fullstory.init({
          orgId: this._orgId,
          debug: this._debug,
          // for local, Dev and UAT environments FullStory will not record sessions
          devMode: this._shouldRecord === false
        });
      },
      "fullstory.init",
      this._logger
    );
  }
  identify(userId) {
    safeExec(
      () => {
        const id = String(userId);
        fullstory.identifyUser(String(id), { displayName: id, email: "" });
      },
      "fullstory.identifyUser",
      this._logger
    );
  }
  anonymize() {
    safeExec(fullstory.anonymizeUser, "fullstory.anonymizeUser", this._logger);
  }
  stop() {
    safeExec(fullstory.stopTracking, "fullstory.stopTracking", this._logger);
  }
  restart() {
    safeExec(
      fullstory.restartTracking,
      "fullstory.restartTracking",
      this._logger
    );
  }
}
export {
  Fullstory
};
